import { useEffect, useState } from 'react';
import { useSetAtom } from 'jotai';
import { userFeaturesAtom } from 'atoms/permissions';
import { tierAtom } from 'atoms/tier';
import { tenantNameAtom } from 'atoms/tenantName';
import apiService from 'api/apiService';

export function useInitializeUser(isAuthenticated: boolean) {
  const [loaded, setLoaded] = useState(false);
  const setFeatures = useSetAtom(userFeaturesAtom);
  const setTier = useSetAtom(tierAtom);
  const setTenantName = useSetAtom(tenantNameAtom);

  const fetchUserConfig = async () => {
    try {
      const userConfig = await apiService.clientConfiguration.get();
      setTier(userConfig.tierInformation);
      setFeatures(userConfig.enabledAddOns ?? []);
      setTenantName(userConfig.tenantName);
    } catch (err) {
      console.error('Failed to load user config:', err);
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => {
    if (!isAuthenticated) return;
    fetchUserConfig();
  }, [isAuthenticated, setFeatures]);

  return loaded;
}
